import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Badge } from './ui/Badge';
export function ChooseRoute() {
  return <SectionWrapper background="navy" data-id="element-14">
      <div className="text-center mb-16" data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-16">
          Elige tu ruta según tu presupuesto
        </h2>
        <p className="text-lg text-slate-300" data-id="element-17">
          No existe un solo camino. Tu situación financiera define por dónde
          empezar.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-18">
        {/* Route A */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-colors" data-id="element-19">
          <div className="flex justify-between items-start mb-6" data-id="element-20">
            <Badge className="bg-emerald-500/20 text-emerald-300 border-emerald-500/30" data-id="element-21">
              Ruta A
            </Badge>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-22">
            Si NO tienes mucho capital
          </h3>
          <p className="text-slate-300 mb-6 text-sm" data-id="element-23">
            Enfoque: empezar pequeño, validar rápido, controlar cashflow
          </p>

          <div className="mb-8" data-id="element-24">
            <span className="text-emerald-400 text-sm font-semibold uppercase tracking-wider" data-id="element-25">
              Modelo sugerido: Arbitraje / Wholesale ligero
            </span>
          </div>

          <ol className="space-y-4 mb-8 list-decimal list-inside text-slate-200 text-sm" data-id="element-26">
            <li data-id="element-27">Abre tu cuenta de vendedor Individual (sin cuota mensual)</li>
            <li data-id="element-28">Aprende a usar herramientas gratuitas de investigación</li>
            <li data-id="element-29">Empieza con retail o online arbitrage con 3-5 productos</li>
            <li data-id="element-30">Reinvierte las ganancias en más inventario</li>
            <li data-id="element-31">Cuando tengas datos, evalúa pasar a wholesale</li>
            <li data-id="element-32">Documenta todo: márgenes, tiempos, proveedores</li>
          </ol>

          <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4" data-id="element-33">
            <div className="flex items-center gap-2 text-red-400 font-semibold mb-3 text-sm" data-id="element-34">
              <AlertTriangle className="h-4 w-4" data-id="element-35" />
              Errores a evitar
            </div>
            <ul className="space-y-2 text-xs text-red-200/80" data-id="element-36">
              <li data-id="element-37">• Comprar inventario grande sin validar demanda</li>
              <li data-id="element-38">• Ignorar las tarifas de almacenamiento a largo plazo</li>
              <li data-id="element-39">• No calcular el margen REAL (incluyendo envío y fees)</li>
            </ul>
          </div>
        </motion.div>

        {/* Route B */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-colors" data-id="element-40">
          <div className="flex justify-between items-start mb-6" data-id="element-41">
            <Badge className="bg-blue-500/20 text-blue-300 border-blue-500/30" data-id="element-42">
              Ruta B
            </Badge>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-43">
            Si SÍ tienes capital para invertir
          </h3>
          <p className="text-slate-300 mb-6 text-sm" data-id="element-44">
            Enfoque: construir un activo escalable y diferenciado
          </p>

          <div className="mb-8" data-id="element-45">
            <span className="text-blue-400 text-sm font-semibold uppercase tracking-wider" data-id="element-46">
              Modelo sugerido: Private Label / Wholesale formal
            </span>
          </div>

          <ol className="space-y-4 mb-8 list-decimal list-inside text-slate-200 text-sm" data-id="element-47">
            <li data-id="element-48">
              Abre cuenta Professional y configura Seller Central completo
            </li>
            <li data-id="element-49">Investiga nichos con herramientas de pago (Helium 10, JS)</li>
            <li data-id="element-50">Contacta proveedores, pide muestras, negocia MOQ</li>
            <li data-id="element-51">Crea un listing optimizado con fotos profesionales</li>
            <li data-id="element-52">Lanza con estrategia de PPC y precio introductorio</li>
            <li data-id="element-53">Escala: más SKUs, A+ Content, Brand Registry</li>
          </ol>

          <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4" data-id="element-54">
            <div className="flex items-center gap-2 text-red-400 font-semibold mb-3 text-sm" data-id="element-55">
              <AlertTriangle className="h-4 w-4" data-id="element-56" />
              Errores a evitar
            </div>
            <ul className="space-y-2 text-xs text-red-200/80" data-id="element-57">
              <li data-id="element-58">• Elegir producto solo por margen sin evaluar competencia</li>
              <li data-id="element-59">• Invertir todo en un solo producto sin diversificar</li>
              <li data-id="element-60">• Saltarse la fase de muestras y control de calidad</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </SectionWrapper>;
}